import React from 'react';
import Svg, { Path } from 'react-native-svg';

const EyeOutlineIcon = ({size = 16}: {size?: number}) => (
  <Svg width={size} height={size} viewBox="0 0 18 18" fill="none">
    <Path
      d="M9 17.333a8.063 8.063 0 01-3.23-.656 8.452 8.452 0 01-2.655-1.792 8.452 8.452 0 01-1.792-2.656A8.063 8.063 0 01.667 9c0-1.153.218-2.236.656-3.25a8.328 8.328 0 011.792-2.646A8.543 8.543 0 015.77 1.323 8.063 8.063 0 019 .667c1.153 0 2.236.218 3.25.656a8.416 8.416 0 012.646 1.781 8.415 8.415 0 011.781 2.646A8.115 8.115 0 0117.333 9a8.063 8.063 0 01-.656 3.23 8.541 8.541 0 01-1.781 2.655 8.328 8.328 0 01-2.646 1.792 8.115 8.115 0 01-3.25.656zm0-1.25c1.972 0 3.646-.69 5.02-2.073 1.376-1.381 2.063-3.052 2.063-5.01 0-1.972-.687-3.646-2.062-5.02C12.646 2.603 10.972 1.916 9 1.916c-1.958 0-3.628.687-5.01 2.062C2.608 5.354 1.917 7.028 1.917 9c0 1.958.69 3.629 2.073 5.01 1.382 1.382 3.052 2.073 5.01 2.073z"
      fill="#98A2B3"
    />
    </Svg>
);

export default EyeOutlineIcon;